export default "__VITE_ASSET__HK2t3OIC__"